import React from "react";
import PropTypes from "prop-types";
import useMediaQuery from "app/hooks/useMediaQuery";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import "./PlanesAsistencia.css";

const ROOT = process.env.REACT_APP_CMS_STATIC;

InfoPlanAsistencia.propTypes = {
  titulo: PropTypes.string,
  nombrePlan: PropTypes.string,
  urlImagen: PropTypes.string,
  tituloDescripcion: PropTypes.string,
  textoDescripcion: PropTypes.string,
  tituloCosto: PropTypes.string,
  textoCosto: PropTypes.string,
  botonCompreAqui: PropTypes.object,
};

const BORDER_TOP_COLOR = "#d7de00";

function InfoPlanAsistencia({
  titulo = "",
  nombrePlan = "",
  urlImagen = "",
  tituloDescripcion = "",
  textoDescripcion = "",
  tituloCosto = "",
  textoCosto = "",
  botonCompreAqui = {},
  ...props
}) {
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");

  const renderCosto = () => (
    <div
      className={
        is4K || isFullHD || isMidLaptop ? "d-flex" : "d-flex flex-wrap"
      }
      style={{ alignItems: "flex-end", gap: "30px" }}
    >
      <CardTypeFolder
        title={tituloCosto}
        titleFullLength={true}
        description={textoCosto}
        borderTopColor={BORDER_TOP_COLOR}
      />
      <div className="btn-size-pa button-top">
        <a
          className="anchor"
          href={botonCompreAqui?.ruta?.url}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={ROOT + botonCompreAqui?.imagen?.urls[0]}
            className="img"
            alt=""
          />
        </a>
      </div>
    </div>
  );

  return (
    <>
      <div
        className={
          is4K
            ? "contenedor d-flex m-5"
            : isFullHD || isMidLaptop
            ? "d-flex ms-5"
            : "d-flex flex-column justify-content-center"
        }
      >
        <div className="d-flex justify-content-center">
          <div className={isIphoneX ? "ms-3 me-3" : "ms-0 me-0"}>
            <img
              className={
                is4K || isFullHD
                  ? "imagen-plan-4K-FullHD mt-4"
                  : isMidLaptop || isIpadLandscape || isIpadPortrait
                  ? "imagen-plan mt-4"
                  : "img-fluid mt-4"
              }
              src={urlImagen}
              alt={nombrePlan}
              style={{
                borderRadius: "30px 30px",
                boxShadow: "0px 3px 6px 0px rgb(000/16%)",
              }}
            />
            <h1 className="feature-card-title-detail">{titulo}</h1>
          </div>
        </div>

        <div className="info-plan-container">
          <div className="mb-0">
            <CardTypeFolder
              title={tituloDescripcion}
              titleFullLength={true}
              description={textoDescripcion}
              borderTopColor={BORDER_TOP_COLOR}
            />
          </div>
          {is4K || isFullHD ? (
            <div
              className={
                isMidLaptop
                  ? "ms-0 me-0"
                  : isIpadLandscape || isIpadPortrait
                  ? "ms-4 me-4"
                  : "ms-5 me-5 lh-sm"
              }
            >
              {renderCosto()}

            </div>
          ) : null}
        </div>
      </div>
      {is4K || isFullHD ? null : (
        <div
          className={
            isMidLaptop
              ? "ms-5 me-5"
              : isIpadLandscape || isIpadPortrait
              ? "ms-4 me-4"
              : "info-plan-container lh-sm"
          }
        >
          {renderCosto()}
        </div>
      )}
    </>
  );
}

export default InfoPlanAsistencia;
